import React, { Component } from 'react'
import style from './index.module.less'
import cls from 'classnames'
import { observer } from 'mobx-react'

@observer
class Index extends Component {
  render() {
    const { store } = this.props
    const { kezhaoList, tempIds, isShowKeZhao } = store
    return (
      <div
        className={style.contentWrap}
        style={{
          border: isShowKeZhao ? '2px dashed #448afe' : '2px solid transparent'
        }}
      >
        <div className={style.content} onClick={store.showKeZhao}>
          <p className={style.contentTitle}>关联客照</p>
          <ul className={cls('clearfix', style.contentList)}>
            {tempIds.map(id => {
              const kezhao = kezhaoList.find(item => item.id == id)
              if (!kezhao) {
                return null
              }
              return (
                <li key={id}>
                  <img
                    src={`${kezhao.coverPath ||
                      kezhao.cover_path}?imageView2/1/w/160/h/160`}
                  />
                </li>
              )
            })}
            <li className={style.listTip}>请在右侧选择客照</li>
          </ul>
        </div>
      </div>
    )
  }
}

export default Index
